@if (matchInvatation) {
    <div class="card m-2">
        <div class="card-body">
            <h5 class="card-title">
                {{ matchInvatation.inviteMessage || 'ADD_MATCH.DEFAULT_MESSAGE' | translate: { name: matchInvatation.player } }}
            </h5>
            <div class="d-flex flex-row justify-content-between">
                <small class="card-subtitle text-muted">{{
                    'SIDEBAR.MATCH_INVITATION_END_AT' | translate: { value: matchInvatation.endsAt | luxon: 'fromNow' }
                }}</small>
                <small class="card-subtitle text-muted">{{ matchInvatation.createdAt | luxon: 'fromNow' }}</small>
            </div>
            <mat-progress-bar
                class="mb-2"
                mode="determinate"
                [value]="remainingTimeProgress"
                [color]="remainingTimeProgressColor"
            ></mat-progress-bar>
            <div class="card-text">
                @for (p of matchInvatation.players; track p; let ix = $index) {
                    <div>
                        <app-chip
                            [id]="matchInvatation.id + '_' + ix"
                            [selected]="getBooleanState(p.state)"
                            [inverted]="true"
                            [color]="p.state === matchInvitationPlayerState.ReservePlayer ? 'blue' : null"
                            >{{ p.displayName }}</app-chip
                        >
                        @if (showDivider(ix)) {
                            <hr class="divider" />
                        }
                    </div>
                }
            </div>
            <div class="d-flex flex-row flex-wrap gap-2">
                @if (showStart) {
                    <button type="button" (click)="startMatch()" class="btn btn-sm btn-success">
                        <i class="fas fa-play"></i>
                        {{ 'SIDEBAR.MATCH_INVITATION_START' | translate }}
                    </button>
                }
                @if (showJoin) {
                    <button (click)="changePlayerState(matchInvitationPlayerState.Accepted)" class="btn btn-sm btn-success">
                        <i class="fas fa-user-plus"></i>
                        {{ 'SIDEBAR.MATCH_INVITATION_JOIN' | translate }}
                    </button>
                }
                @if (showReserve) {
                    <button (click)="changePlayerState(matchInvitationPlayerState.ReservePlayer)" class="btn btn-sm btn-warning">
                        <i class="fas fa-question"></i> {{ 'SIDEBAR.MATCH_INVITATION_RESERVE_PLAYER' | translate }}
                    </button>
                }
                @if (showRefuse) {
                    <button (click)="changePlayerState(matchInvitationPlayerState.Refused)" class="btn btn-sm btn-danger">
                        <i class="fas fa-minus-circle"></i> {{ 'SIDEBAR.MATCH_INVITATION_REFUSE' | translate }}
                    </button>
                }
                @if (idPlayer === matchInvatation.idPlayer) {
                    <button [swal]="deleteSeasonSwal" class="btn btn-sm btn-danger">
                        <i class="fas fa-ban"></i> {{ 'SIDEBAR.MATCH_INVITATION_CANCEL' | translate }}
                    </button>
                }
                @if (idPlayer === matchInvatation.idPlayer) {
                    <button (click)="openInvitationModal()" class="btn btn-sm btn-primary">
                        <i class="fas fa-pen"></i> {{ 'SIDEBAR.MATCH_INVITATION_EDIT' | translate }}
                    </button>
                }
                <swal
                    #deleteSeasonSwal
                    [title]="'SIDEBAR.MATCH_INVITATION_CANCEL_CONFIRM_TITLE' | translate"
                    [confirmButtonText]="'COMMON.OK' | translate"
                    [cancelButtonText]="'COMMON.CANCEL' | translate"
                    [showCancelButton]="true"
                    [icon]="'question'"
                    (confirm)="cancel()"
                    [confirmButtonColor]="'#96242f'"
                >
                </swal>
            </div>
            @if (matchInvatation.comments?.length) {
                <div class="mt-2">
                    @for (comment of matchInvatation.comments; track $index) {
                        <app-match-invitation-comment [comment]="comment"></app-match-invitation-comment>
                    }
                </div>
            }
            <div class="mt-2">
                <app-match-invitation-add-comment
                    [placeholder]="'SIDEBAR.MATCH_INVITATION_NEW_COMMENT_PLACEHOLDER' | translate"
                    (sentComment)="addComment($event)"
                ></app-match-invitation-add-comment>
            </div>
        </div>
    </div>
}
